<template>
	<div class="editor-container" :style="{ height: height + 'px' }">
		<div ref="editor" class="editor"></div>
	</div>
</template>

<script>
	import E from 'wangeditor'

	export default {
		props: {
			value: {
				type: String,
				default: ''
			},
			height: {
				type: Number,
				default: 500
			},
			uploadUrl: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				editor: null,
				currentValue: ''
			}
		},
		watch: {
			value(val) {
				if (val !== this.currentValue) {
					this.editor.txt.html(val)
				}
			}
		},
		mounted() {
			this.initEditor()
		},
		beforeDestroy() {
			if (this.editor) {
				this.editor.destroy()
				this.editor = null
			}
		},
		methods: {
			initEditor() {
				this.editor = new E(this.$refs.editor)

				// 配置菜单
				this.editor.config.menus = [
					// 基础功能
					'head', // 标题
					'bold', // 加粗
					'italic', // 斜体
					'underline', // 下划线
					'strikeThrough', // 删除线
					'foreColor', // 文字颜色
					'backColor', // 背景色
					'link', // 链接
					'list', // 列表（有序/无序）
					'justify', // 对齐方式
					'quote', // 引用
					'image', // 图片
					'table', // 表格
					'code', // 代码块
					'splitLine', // 分割线

					// 扩展功能（需自行注册）
					'lineHeight', // 行间距
					'indent', // 首行缩进
					'paragraphSpace', // 段间距
					'fontFamily', // 字体
					'fontSize', // 字号

					// 系统功能
					'undo', // 撤销
					'redo', // 重做
					'fullScreen' // 全屏
				]

				// 自定义图片上传（使用fetch API）
				this.editor.config.customUploadImg = async (resultFiles, insertImgFn) => {
					const file = resultFiles[0]
					const formData = new FormData()
					formData.append('file', file)

					// 显示上传loading
					const loading = this.$loading({
						lock: true,
						text: '图片上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					})

					try {
						const response = await fetch(this.uploadUrl, {
							method: 'POST',
							body: formData
							// 注意：不要设置 Content-Type 头，浏览器会自动设置正确的 multipart/form-data 边界
						})

						if (!response.ok) {
							throw new Error(`HTTP error! status: ${response.status}`)
						}

						const data = await response.json()

						// 兼容两种响应格式
						let imgUrl = ''
						if (data.success) {
							imgUrl = `https://www.fossnet.cn/api/` + data.data.path ||
								`https://www.fossnet.cn/api/` + data.data.url
						} else if (data.errno === 0) {
							imgUrl = data.data.url
						}

						if (!imgUrl) {
							throw new Error('无法获取图片URL')
						}

						// 补全完整URL
						if (!imgUrl.startsWith('http')) {
							imgUrl = `${window.location.origin}/${imgUrl.replace(/^\//, '')}`
						}

						insertImgFn(imgUrl)
					} catch (error) {
						this.$message.error(error.message || '图片上传失败')
						console.error('上传错误:', error)
					} finally {
						loading.close()
					}
				}

				// 监听内容变化
				this.editor.config.onchange = html => {
					this.currentValue = html
					this.$emit('input', html)
					this.$emit('change', html)
				}

				this.editor.create()
				this.editor.txt.html(this.value)
				this.currentValue = this.value
			}
		}
	}
</script>